import { Component, OnDestroy, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatFormFieldModule } from '@angular/material/form-field';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { APIResponse, AppData, NotificationData, ObjectUtils, TemplateUtils, UserSettings } from 'fakturnia-shared';
import { MatInputModule } from '@angular/material/input';
import { Subscription, take } from 'rxjs';
import { SettingsApiService } from 'shared/services/api/settings.api.service';
import { SettingsService } from 'shared/services/settings.service';
import { debounce } from 'lodash-es';
import { SnackbarService } from 'shared/services/snackbar.service';

@Component({
  selector: 'app-documents-symbols',
  standalone: true,
  imports: [CommonModule, MatFormFieldModule, MatInputModule, ReactiveFormsModule],
  templateUrl: './documents-symbols.component.html',
  styleUrl: './documents-symbols.component.scss'
})
export class DocumentsSymbolsComponent implements OnInit, OnDestroy {

  private _subscriptions: Subscription[] = []
  private static readonly _hiddenTypes = new Set([
    'FakturaVATMarza', 'FakturaVATMarzaProforma', 'FakturaMPP', 'FakturaKoncowa', 'FakturaWDT'
  ])
  documentTypes = TemplateUtils.documents.filter(d => !DocumentsSymbolsComponent._hiddenTypes.has(d.id))
  documentTypesControls: any = []
  documentSymbols = {}
  constructor(
    private _settingsService: SettingsService,
    private _settingsApiService: SettingsApiService,
    private _snackbarService: SnackbarService
  ) {

    this._updateDocumentSymbols = debounce(this._updateDocumentSymbols, 500)

    for (let doc of this.documentTypes) {
      this.documentTypesControls.push({
        id: doc.id,
        name: doc.name,
        control: new FormControl('')
      })
    }
  }

  ngOnInit(): void {

    this._subscriptions.push(
      this._settingsService.getUserSettings().subscribe({
        next: (userSettings: UserSettings) => {
          this.documentSymbols = ObjectUtils.getNestedValue(userSettings, "settings.autocomplete.documentSymbols")
          Object.keys(this.documentSymbols).forEach((key) => {
            const control = this.documentTypesControls.find((control: any) => control.id === key);
            if (control) {
              control.control.setValue(this.documentSymbols[key], { emitEvent: false })
            }
          })
        }
      }))

    for (let doc of this.documentTypesControls) {
      this._subscriptions.push(
        doc.control.valueChanges.subscribe((value) => {
          this._updateDocumentSymbols(doc.id, value)
        })
      )
    }
  }

  private _updateDocumentSymbols(id, value) {

    if(this.documentSymbols[id] == value) return
    this._settingsApiService.updateDocumentSymbols(id, value)
      .pipe(take(1))
      .subscribe({
        next: (response: APIResponse) => {

          this._settingsService.refreshSettings()

          if (!response.success) {
            this._snackbarService.showSnackBar(
              "Nie udało się zapisać zmian",
              "error", 
              4000
            )
            return
          }

          this._snackbarService.showSnackBar(
            "Zapisano zmiany",
            "success", 
            4000
          )

        }
      })
  }
  ngOnDestroy(): void {
    this._subscriptions.forEach(sub => sub.unsubscribe());
  }
}
